import { render, staticRenderFns } from "./approvepayment.vue?vue&type=template&id=60cb94d0&"
import script from "./approvepayment.vue?vue&type=script&lang=js&"
export * from "./approvepayment.vue?vue&type=script&lang=js&"
import style0 from "./approvepayment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./approvepayment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports